import { render } from "./indexHeader.vue?vue&type=template&id=2af5076b&scoped=true"
import script from "./indexHeader.vue?vue&type=script&lang=js"
export * from "./indexHeader.vue?vue&type=script&lang=js"

import "./indexHeader.vue?vue&type=style&index=0&id=2af5076b&lang=less&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af5076b"]])

export default __exports__